import React, { Component } from "react";
import { connect } from "react-redux";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";
import Aux from "../AUXX/Auxx";
import CssClasses from "./LayoutPrematch.css";
import Header from "../../Containers/Header/Header";
import LeftSectionPickers from "../../Containers/LeftSectionPickers/LeftSectionPickers";
import RightSectionTerminalActions from "../../Containers/RightSectionTerminalActions/RightSectionTerminalActions";
import PrematchEventList from "../../Containers/PrematchEventList/PrematchEventList";
import CefMonitor from "../CefMonitor/CefMonitor";
import FullscreenLoader from "../../Components/UI/FullscreenLoader/FullscreenLoader";
import FullscreenModalPopup from "../../Components/UI/FullscreenModalPopup/FullscreenModalPopup";
import FullscreenIFrame from "../../Components/FullscreenIFrame/FullscreenIFrame";
import InfoContainer from "../../Components/InfoContainer/InfoContainer";
import AdditionalBets from "../../Components/AdditionalBets/AdditionalBets";
import { ConvertLanguageCodeToJezikID } from "../../HOCs/Helpers/LanguageConverter";
import * as ZebraErrorCodes from "../../HOCs/Constants/ZebraErrorCodes";
import * as MostPlayedOptionIDs from "../../HOCs/Constants/MostPlayedOptionID";
import * as PickerIDs from "../../HOCs/Constants/PickerID";

import * as LocalStorageKeys from "../../HOCs/Constants/LocalStorageKeys";

import {
  GetSportTournamentItems,
  GetActivePairItems,
  GetTipNamesForMainBets,
  GetMostTippedPairs,
  GetMostTippedSports,
  GetSuperTipPairs,
  GetFavoritPlusPairs,
  GetTopLeagues,
  GetAdditionalBetNamesForPair,
  GetAdditionalBetOddsForPair,
  GetMainBets,
  GetCalendarItems
} from "../../Communication/PrematchInfoServicesHandler";

let moment = require("moment");

class Layout extends Component {
  currentText = "";

  timerRef = null;

  clicks = 0;
  timer = null;
  timeout = 500; // time between each click

  state = {
    infoMessage: null,
    sports: [],
    categories: [],
    tournaments: [],
    matches: [],
    groups: [],
    rawEventList: [],
    additionalBetsText: [],
    additionalBetsList: []
  };

  componentDidMount() {
    //dohhvati glavne oklade
    this.getMainBets();

    //inicijalno popuni
    this.handleCalendarChange();

    //dohvati kalendar
    var tmpDate = new Date();

    GetCalendarItems(-tmpDate.getTimezoneOffset(), function(val) {
      console.log("GOT CALENDAR ITEMS: ", val);
    });

    //podesi timer
    window.onload = this.resetTimer.bind(this);
    window.onmousemove = this.resetTimer.bind(this);
    window.onmousedown = this.resetTimer.bind(this); // catches touchscreen presses as well
    window.ontouchstart = this.resetTimer.bind(this); // catches touchscreen swipes as well
    window.ontouchmove = this.resetTimer.bind(this);
    window.onclick = this.resetTimer.bind(this); // catches touchpad clicks as well
    window.onkeypress = this.resetTimer.bind(this);
    window.addEventListener("scroll", this.resetTimer.bind(this), true); // improved; see comments
  }

  resetTheApp() {
    console.log("APP RESET!");
    //location.href = 'logout.html'

    //bacaj na najtipovanije
    this.props.onChangeLastUsedPicker(PickerIDs.MOST_PLAYED_OPTIONS);
    this.props.onChangeMostPlayedButtonItem(MostPlayedOptionIDs.MOST_TIPPED);

    //gasi extra bets ako su vanka
    this.props.setShouldQuickCloseExtraBets(true);
    this.props.setIsShowingBonusInfo(false);
    this.props.onSetPrematchExtraBetsID(-1);
    this.props.setCanShowExtraPrematchBets(true);

    //resetraj i kategorije
    this.props.onChangeCurrentCategory(0);
    this.props.onChangeCurrentLeague(-1);

    //gasi i info ako je vani
    this.props.setTerminalActionsActiveButton(0);

    setTimeout(() => {
      this.props.setShouldQuickCloseExtraBets(false);
    }, 100);
  }

  resetTimer() {
    clearTimeout(this.timerRef);
    this.timerRef = setTimeout(
      function() {
        this.resetTheApp();
      }.bind(this),
      300000
    );
    // 1000 milliseconds = 1 second

    //javi kroz storage
    localStorage.setItem(
      LocalStorageKeys.LOCALSTORAGE_LAST_USER_INTERACTION,
      JSON.stringify({ src: "prematch", time: new Date() })
    );
  }

  resetTimerForSelf() {
    clearTimeout(this.timerRef);
    this.timerRef = setTimeout(
      function() {
        this.resetTheApp();
      }.bind(this),
      300000
    );
  }

  getMainBets() {
    GetMainBets(
      ConvertLanguageCodeToJezikID(this.props.currentLanguage),
      this.GetMainBets_Callback.bind(this)
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    //pogledaj je li se promjenio property
    if (prevProps.activeCalendarItemID !== this.props.activeCalendarItemID) {
      this.handleCalendarChange();
    }
    if (
      prevProps.currentSportID !== this.props.currentSportID ||
      prevProps.currentLeagueID !== this.props.currentLeagueID ||
      prevProps.currentCategoryID !== this.props.currentCategoryID
    ) {
      if (
        this.props.activeCalendarItemID === 9 &&
        prevProps.currentCategoryID === this.props.currentCategoryID &&
        prevProps.currentLeagueID === this.props.currentLeagueID
      ) {
        //zovi handle calendar change jer treba load sa servera
        //ali samo ako nije bila promjena na kategorijama  i ligama, tada nema potrebe
        this.handleCalendarChange();
      } else if (
        this.props.activeMostPlayedButtonID === MostPlayedOptionIDs.MOST_TIPPED
      ) {
        //opet zovi server jer se od tamo povlaci
        this.handleMostPlayedOptionChange();
      } else {
        //obicna promjena sporta
        console.log("SPORT PROMIJENJEN!");
        //samo refreshaj kesirano
        this.updateDisplayedSports();
      }
    }

    //dohvati additional bets ako treba
    //  probaj dohvat
    if (
      prevProps.prematchExtraBetsID !== this.props.prematchExtraBetsID &&
      this.props.prematchExtraBetsID > 0
    ) {
      //zovi
      this.getAdditionalBetsInfo(this.props.prematchExtraBetsID);
    }

    if (
      prevProps.activeMostPlayedButtonID !== this.props.activeMostPlayedButtonID
    ) {
      if (
        this.props.activeMostPlayedButtonID === MostPlayedOptionIDs.PREMATCH
      ) {
        //oznaci prvi dan kalendara i gasi ligu
        this.props.onChangeCurrentLeague(-1);
        this.props.onChangeCalendarItem(1, new Date());
        this.props.onChangeLastUsedPicker(PickerIDs.CALENDAR);

        this.handleCalendarChange();
      } else {
        if (
          this.props.activeMostPlayedButtonID ===
          MostPlayedOptionIDs.MOST_TIPPED
        ) {
          //odaberi trenutno sve sportove
          this.props.onChangeSportPrematch(-10);
        }

        //console.log("LANG CHANGED!");
        this.handleMostPlayedOptionChange();
      }
    }

    //na promjenu jezika rokni opet sve
    if (prevProps.currentLanguage !== this.props.currentLanguage) {
      //promjena jezika, refresh svega
      this.handleCalendarChange();
      this.getMainBets();
    }
  }

  getAdditionalBetsInfo = matchID => {
    GetAdditionalBetNamesForPair(
      ConvertLanguageCodeToJezikID(this.props.currentLanguage),
      matchID,
      this.getAdditionalBetNamesForPair_callback.bind(this)
    );
  };

  getAdditionalBetNamesForPair_callback(data) {
    if (!data) {
      //cancel
      console.log("NO DATA...");
      return;
    }

    console.log("Received names: ", data);

    //obradi
    var betsText = [];
    var betsList = [];

    //spremi u state
    data.forEach(bi => {
      //ako vec postoji, odustani
      if (betsList.findIndex(x => x.svoID === bi.IDOkladaVrsta) !== -1) {
        //vozi dalje
        return;
      }

      var betForList = {
        Aktivno: true,
        Cleared: 0,
        IDOklada: bi.IDOkladaVrsta,
        Naziv: bi.OkladaVrstaPrevod,
        Opis: bi.OpisPrevod,
        Omoguciti: true,
        PosebnaVrijednost: null,
        Prikazati: true,
        Redoslijed: bi.RedniBrojIspis,
        UpdateStamp: 0,
        UtakmicaID: 0,
        kpID: 0,
        svoGrupID: bi.IDOkladaVrsta,
        svoID: bi.IDOkladaVrsta,
        xKombi: 0,
        VrstaTipaID: bi.VrstaTipaID,
        Exkluziv1: bi.Exkluziv1,
        Exkluziv2: bi.Exkluziv2
      };

      var betForText = {
        AzijskiFlag: 0,
        BrojTipova: 0,
        DugiNaziv: bi.OkladaVrstaPrevod,
        HederNaziv: bi.OkladaVrstaPrevod,
        HederOklada: 0,
        HederRedoslijed: 0,
        Jezik: this.state.currentLanguage,
        Naziv: bi.OkladaVrstaPrevod,
        PosebnaVrijednostGrup: "",
        Redoslijed: bi.RedniBrojIspis,
        SpecNaziv: "",
        SportID: this.state.currentSportID,
        predznakNaslov: 0,
        svoGrupID: bi.IDOkladaVrsta,
        svoID: bi.IDOkladaVrsta,
        tipovi: bi.ListaTipova,
        Exkluziv1: bi.Exkluziv1,
        Exkluziv2: bi.Exkluziv2
      };

      betsList.push(betForList);
      betsText.push(betForText);
    });

    //console.log("obradjene names su ", bets);

    this.setState(
      {
        additionalBetsText: betsText,
        additionalBetsList: betsList
      },
      () => {
        //i zovi dalje dohvat oddova
        GetAdditionalBetOddsForPair(
          ConvertLanguageCodeToJezikID(this.props.currentLanguage),
          this.props.prematchExtraBetsID,
          this.getAdditionalBetOddsForPair_callback.bind(this)
        );
      }
    );
  }

  getAdditionalBetOddsForPair_callback(data) {
    if (!data) {
      console.log("NO DATA...");
      return;
    }

    console.log("Received odds: ", data);

    //obradi
    var odds = [];

    data.forEach(pair => {
      var odd = {};

      //izvuci kvote
      var kvote = pair.KvotaList;

      //pripremi si tipove iz textova
      var betText = this.state.additionalBetsText.find(
        x => x.svoID === pair.OkladaVrstaID
      );
      var tipovi = [];

      if (betText) {
        tipovi = betText.tipovi;
      }

      kvote.forEach(kv => {
        var tip = tipovi.find(x => x.TipPojedinacno === kv.Tip);

        odd = {
          betID: pair.OkladaVrstaID,
          changeDirection: 0,
          id: kv.IDParKvota,
          isActive: true,
          isEnabled: true,
          isShown: true,
          kategorijaPonudeID: 1,
          longName: tip ? tip.Naziv : kv.Tip,
          matchID: 758605,
          order: 0,
          shortName: tip ? tip.Naziv : kv.Tip,
          sportVrstaOkladaID: pair.OkladaVrstaID,
          value: kv.KvotaVrijednost,
          margin: kv.Margina
        };

        if (pair.OkladaVrstaID === 430) {
          //kosarka zbroj koseva igraca
          odd.margin = pair.DomacinNaziv;
        }

        //pushaj
        odds.push(odd);
      });
    });

    //napravi si kopiju meceva
    var matches = JSON.parse(JSON.stringify(this.state.matches));

    //nadji taj mec
    var matchIdx = matches.findIndex(
      x => x.id === this.props.prematchExtraBetsID
    );

    if (matchIdx !== -1) {
      //zalijepi
      //console.log("BET INFO BEFORE: ", matches[matchIdx].betInfo);
      //matches[matchIdx].betInfo = matches[matchIdx].betInfo.concat(odds);
      matches[matchIdx].betInfo = odds;
      //console.log("BET INFO AFTER: ", matches[matchIdx].betInfo);
    }

    this.setState({ additionalBetsOdds: odds, matches: matches });
  }

  updateDisplayedSports() {
    // if (this.props.activeCalendarItemID > 0) {
    //   //u kalendaru je
    //   //this.handleCalendarChange();
    // } else if (this.props.activeMostPlayedButtonID > 0) {
    //   //u most played je
    //   //this.handleMostPlayedOptionChange();
    // }

    //filtriraj iz statea
    var eventList = this.state.rawEventList;

    //console.log("XX EVENT LIST IS ", eventList);

    if (
      this.props.activeMostPlayedButtonID === MostPlayedOptionIDs.TOP_LEAGUES
    ) {
      //filtriraj za top lige po trenutnoj top ligi
      var newEventList = eventList.filter(
        x =>
          x.id ===
          (this.props.currentLeagueID === 0 //ako gleda sve lige usporedi s nicim (true), inace vrati id koji trazimo
            ? x.id
            : this.props.currentLeagueID)
      );
    } else {
      //filtriraj za ostale pizdarije po sportu gore
      var newEventList = eventList.filter(
        x =>
          x.sportID ===
          (this.props.currentSportID === -10 //ako gleda sve sportove usporedi s nicim (true), inace vrati id koji trazimo
            ? x.sportID
            : this.props.currentSportID)
      );

      //ako je odabrana kategorija neka onda jos i po njoj
      if (this.props.currentCategoryID > 0) {
        //filtriraj
        newEventList = newEventList.filter(
          x => x.categoryID === this.props.currentCategoryID
        );
      }

      //ako je odabran sport, onda jos i po njemu
      if (this.props.currentLeagueID > 0) {
        newEventList = newEventList.filter(
          x => x.leagueID === this.props.currentLeagueID
        );
      }

      var categories = this.state.categories;

      if (this.props.currentSportID === -10) {
        //cisti
        this.props.setPrematchCategoriesInfo(null);
      } else {
        //cisti
        categories = categories.filter(
          x => x.IDSport === this.props.currentSportID
        );

        let matchCounter = 0;

        //podesi count svakoj
        categories.forEach(c => {
          var tmpList = this.state.rawEventList.filter(
            //iz raw zato da budu sve dostupne za brojalicu
            x => x.categoryID === c.IDCategory
          );

          //ako zelis broj turnira onda ne treba ici u petlju dole nego samo len od tmplist

          //console.log("LISTA JE ", tmpList);

          c.EventCount = 0;
          var matchCount = 0;
          var tournamentCount = 0;

          tmpList.forEach(tournament => {
            c.EventCount += tournament.matches.length;
            tournamentCount++;

            var t = c.Tournaments.find(x => x.IDTournament === tournament.id);

            if (t) {
              t.EventCount = tournament.matches.length;
              matchCount += tournament.matches.length;
            }
          });

          matchCounter += c.EventCount;

          //format
          c.EventCount = tournamentCount + "/" + matchCount + "";
        });

        //push na beginning - unshift
        categories.unshift({
          IDCategory: 0,
          TitleCategory: "Sve kategorije",
          IDSport: 0,
          TitleSport: 0,
          EventCount: matchCounter,
          IconCode: "xxx"
        });

        //ako kategorije nemaju trenutno odabranu, odaberi sve
        if (
          !categories.find(x => x.IDCategory === this.props.currentCategoryID)
        ) {
          this.props.onChangeCurrentCategory(0); //sve
        }

        this.props.setPrematchCategoriesInfo(categories);
      }
    }

    //console.log("FILTERED!");
    this.hideExtraBetsPopup();

    this.setState({ groups: newEventList });

    this.props.stopLoading(true);
  }

  getRequestLastMinOffset() {
    switch (this.props.activeCalendarItemID) {
      case 10:
        return 180; //3h
      case 11:
        return 360; //6h
      case 12:
        return 720; //12h
      default:
        return 0;
    }
  }

  handleMostPlayedOptionChange() {
    if (this.props.lastUsedPickerID !== PickerIDs.MOST_PLAYED_OPTIONS) {
      console.log("THIS PICKER WASNT USED... MOST_PLAYED_OPTIONS");
      return;
    }

    //gasi kalendar
    this.props.onChangeCalendarItem(-1, new Date());

    switch (this.props.activeMostPlayedButtonID) {
      case MostPlayedOptionIDs.MOST_TIPPED:
        this.loadMostTippedPairs();
        break;
      case MostPlayedOptionIDs.SUPERTIP:
        this.loadSupertipPairs();
        break;
      case MostPlayedOptionIDs.FAVORIT_PLUS:
        this.loadFavoritPlusPairs();
        break;
      case MostPlayedOptionIDs.TOP_LEAGUES:
        this.loadTopLeaguesPairs();
        break;
      default:
        break;
    }
  }

  GetMainBets_Callback(data) {
    console.log("IN CALLBACK FOR GetMainBets_Callback WITH DATA ", data);

    //spremaj u state
    this.props.setAllBetsText(data);
  }

  loadMostTippedPairs() {
    this.props.startLoading(false, false);

    //prvo sportove dohvati
    GetMostTippedSports(
      ConvertLanguageCodeToJezikID(this.props.currentLanguage),
      this.GetMostTippedSports_Callback.bind(this)
    );
  }

  GetMostTippedSports_Callback(data) {
    console.log(
      "IN CALLBACK FOR loadMostTippedSports_Callback WITH DATA ",
      data
    );

    if (!data) {
      console.log("NO DATA!");
      this.showLoadingErrorMessage();
      return;
    }

    //obradi listu sportova i spremi ju u picker
    let sports = [];

    //provjeri da nema dvije kosarke
    let filteredtmp = data.filter(x => x.IDSport === 3); //kosarka
    let hasTwoBasketballs = false;

    if (filteredtmp.length > 1) {
      //ima
      hasTwoBasketballs = true;
    }

    data.forEach(el => {
      if (hasTwoBasketballs) {
        //push samo ako je 3 tipa
        if (el.IDSport === 3) {
          //kosarka, provjeri
          if (el.MoguciTipovi.split(",").length === 3) {
            //push
            sports.push({
              IDSport: el.IDSport,
              Title: el.NazivSport,
              PossibleBets: el.MoguciTipovi,
              BetTypeID: el.VrstaTipaID
            });
          } else {
            //ignore
          }
        } else {
          //normalan push
          sports.push({
            IDSport: el.IDSport,
            Title: el.NazivSport,
            PossibleBets: el.MoguciTipovi,
            BetTypeID: el.VrstaTipaID
          });
        }
      } else {
        //obican push
        sports.push({
          IDSport: el.IDSport,
          Title: el.NazivSport,
          PossibleBets: el.MoguciTipovi,
          BetTypeID: el.VrstaTipaID
        });
      }
    });

    this.setState({ sports: sports });

    this.generateAndSavePicker(sports);

    GetMostTippedPairs(
      ConvertLanguageCodeToJezikID(this.props.currentLanguage),
      this.props.currentSportID === -10 ? 0 : this.props.currentSportID, //-10 su svi sportovi i saljes 0)
      50,
      this.GetMostTippedPairs_Callback.bind(this)
    );
  }

  GetMostTippedPairs_Callback(data) {
    console.log("IN CALLBACK FOR GetMostTippedPairs_Callback WITH DATA ", data);

    if (!data) {
      console.log("NO DATA!");
      this.showLoadingErrorMessage();
      return;
    }

    //obradi listu parova
    //temp, makni
    let eventList = [];
    let matches = [];
    let tmpDate = new Date();

    let group = {};

    let sport = this.state.sports.find(
      x => x.IDSport === this.props.currentSportID
    );

    group.sportID = this.props.currentSportID;
    group.id = this.props.currentSportID;
    group.country = "NAJTIPOVANIJI";
    group.league =
      this.props.currentSportID !== -10
        ? sport
          ? sport.Title
          : ""
        : "Svi sportovi";
    group.matches = [];

    //sortiraj parove po brojju oklada desc
    var sortedPairs = data.par;

    // sortedPairs.sort((a, b) => {
    //   return b.BrojOklada - a.BrojOklada;
    // });

    // console.log("SORTED ", sortedPairs);

    sortedPairs.forEach(pair => {
      let betInfo = [];
      let isSuperTip = false;

      //dohvati kvote
      var kvote = data.kvota.filter(x => x.ParID === pair.IDPar);

      //za svaku kvotu salji u bet info
      kvote.forEach(kv => {
        betInfo.push({
          betID: kv.IDParKvota,
          changeDirection: 0,
          id: kv.IDParKvota,
          isActive: true,
          isEnabled: true,
          isShown: true,
          kategorijaPonudeID: 1,
          longName: kv.Tip,
          matchID: kv.ParID,
          order: 0,
          shortName: kv.Tip,
          sportVrstaOkladaID: 0,
          value: kv.KvotaVrijednost
        });

        if (kv.SuperTip === 1) {
          isSuperTip = true;
        }
      });

      var tmpMatch = {
        id: pair.IDPar,
        homeTeam: pair.DomacinNaziv,
        guestTeam: pair.GostNaziv,
        startTime: moment(pair.DatumUtakmice)
          .add(-tmpDate.getTimezoneOffset(), "m")
          .toDate(),
        betInfo: betInfo,
        isSuperTip: isSuperTip,
        sportID: pair.SportID,
        betRadarID: pair.BrMatchID
      };

      group.matches.push(tmpMatch);
      matches.push(tmpMatch);
    });

    eventList.push(group);
    //postavi state
    this.setState({ groups: eventList, matches: matches });

    this.props.stopLoading(false);
  }

  loadSupertipPairs() {
    this.props.startLoading(false, false);

    GetSuperTipPairs(
      ConvertLanguageCodeToJezikID(this.props.currentLanguage),
      this.GetSuperTipPairs_Callback.bind(this)
    );
  }

  GetSuperTipPairs_Callback(data) {
    console.log("INNN CALLBACK FOR GetSuperTipPairs_Callback WITH DATA ", data);

    if (!data) {
      console.log("NO DATA!");
      this.showLoadingErrorMessage();
      return;
    }

    //prazni listu sportova gore
    this.setState({ sports: [] });
    //this.props.setPrematchPickerInfo([]);
    this.props.onChangeSportPrematch(-10);

    //obradi listu parova
    //temp, makni
    //let betID = 0;
    let eventList = [];
    let matches = [];
    let tmpDate = new Date();

    let group = {};

    let sport = this.state.sports.find(
      x => x.IDSport === this.props.currentSportID
    );

    group.sportID = this.props.currentSportID;
    group.id = this.props.currentSportID;
    group.country = "SUPER TIP";
    group.league =
      this.props.currentSportID !== -10
        ? sport
          ? sport.Title
          : ""
        : "Svi sportovi";
    group.matches = [];

    //sortiraj parove po brojju oklada desc
    var sortedPairs = data.par;

    // sortedPairs.sort((a, b) => {
    //   return b.BrojOklada - a.BrojOklada;
    // });

    // console.log("SORTED ", sortedPairs);

    sortedPairs.forEach(pair => {
      let betInfo = [];

      // for (let k = 1; k <= 40; k++) {
      //   betID++;

      //   betInfo.push({
      //     id: betID,
      //     betTypeID: k,
      //     betOdds: (Math.floor(Math.random() * 80) * 0.1 + 1).toFixed(2)
      //   });
      // }

      //dohvati kvote
      var kvote = data.kvota.filter(x => x.ParID === pair.IDPar);

      //za svaku kvotu salji u bet info
      kvote.forEach(kv => {
        betInfo.push({
          betID: kv.IDParKvota,
          changeDirection: 0,
          id: kv.IDParKvota,
          isActive: true,
          isEnabled: true,
          isShown: true,
          kategorijaPonudeID: 1,
          longName: kv.Tip,
          matchID: kv.ParID,
          order: 0,
          shortName: kv.Tip,
          sportVrstaOkladaID: 0,
          value: kv.KvotaVrijednost
        });
      });

      var tmpMatch = {
        id: pair.IDPar,
        homeTeam: pair.DomacinNaziv,
        guestTeam: pair.GostNaziv,
        startTime: moment(pair.DatumUtakmice)
          .add(-tmpDate.getTimezoneOffset(), "m")
          .toDate(),
        betInfo: betInfo,
        //isSuperTip: pair.SuperTip === 1
        isSuperTip: true,
        sportID: pair.SportID,
        betRadarID: pair.BrMatchID
      };

      group.matches.push(tmpMatch);
      matches.push(tmpMatch);
    });

    console.log("EVENTI SU: ", eventList);

    eventList.push(group);
    //postavi state
    this.setState({ groups: eventList, matches: matches });

    this.props.stopLoading(false);
  }

  loadFavoritPlusPairs() {
    this.props.startLoading(false, false);

    GetFavoritPlusPairs(
      ConvertLanguageCodeToJezikID(this.props.currentLanguage),
      this.GetFavoritPlusPairs_Callback.bind(this)
    );
  }

  GetFavoritPlusPairs_Callback(data) {
    console.log(
      "IN CALLBACK FOR GetFavoritPlusPairs_Callback WITH DATA ",
      data
    );

    if (!data) {
      console.log("NO DATA!");
      this.showLoadingErrorMessage();
      return;
    }

    //prazni listu sportova gore
    this.setState({ sports: [] });
    //this.props.setPrematchPickerInfo([]);
    this.props.onChangeSportPrematch(-10);

    //obradi listu parova
    //temp, makni
    let betID = 0;
    let eventList = [];
    let matches = [];
    let tmpDate = new Date();

    let group = {};

    let sport = this.state.sports.find(
      x => x.IDSport === this.props.currentSportID
    );

    group.sportID = this.props.currentSportID;
    group.id = this.props.currentSportID;
    group.country = "FAVORIT SUPER TIP PLUS";
    group.league =
      this.props.currentSportID !== -10
        ? sport
          ? sport.Title
          : ""
        : "Svi sportovi";
    group.matches = [];

    //sortiraj parove po brojju oklada desc
    var sortedPairs = data.par;
    var tipNames = data.MoguciTipovi;

    group.tipNames = tipNames;
    group.isFavoritPlus = true;

    // sortedPairs.sort((a, b) => {
    //   return b.BrojOklada - a.BrojOklada;
    // });

    // console.log("SORTED ", sortedPairs);

    sortedPairs.forEach(pair => {
      let betInfo = [];

      // for (let k = 1; k <= 40; k++) {
      //   betID++;

      //   betInfo.push({
      //     id: betID,
      //     betTypeID: k,
      //     betOdds: (Math.floor(Math.random() * 80) * 0.1 + 1).toFixed(2)
      //   });
      // }

      //dohvati kvote
      var kvote = data.kvota.filter(x => x.ParID === pair.IDPar);

      //za svaku kvotu salji u bet info
      kvote.forEach(kv => {
        betInfo.push({
          betID: kv.IDParKvota,
          changeDirection: 0,
          id: kv.IDParKvota,
          isActive: true,
          isEnabled: true,
          isShown: true,
          kategorijaPonudeID: 1,
          longName: kv.Tip,
          matchID: kv.ParID,
          order: 0,
          shortName: kv.Tip,
          sportVrstaOkladaID: 0,
          value: kv.KvotaVrijednost
        });
      });

      var tmpMatch = {
        id: pair.IDPar,
        homeTeam: pair.DomacinNaziv,
        guestTeam: pair.GostNaziv,
        startTime: moment(pair.DatumUtakmice)
          .add(-tmpDate.getTimezoneOffset(), "m")
          .toDate(),
        betInfo: betInfo,
        //isSuperTip: pair.SuperTip === 1
        isSuperTip: false,
        sportID: pair.SportID,
        betRadarID: pair.BrMatchID
      };

      group.matches.push(tmpMatch);
      matches.push(tmpMatch);
    });

    eventList.push(group);
    //postavi state
    this.setState({ groups: eventList, matches: matches });

    this.props.stopLoading(false);
  }

  loadTopLeaguesPairs() {
    this.props.startLoading(false, false);

    var tmpDate = new Date();

    GetTopLeagues(
      ConvertLanguageCodeToJezikID(this.props.currentLanguage),
      -tmpDate.getTimezoneOffset(),
      this.GetTopLeagues_Callback.bind(this)
    );
  }

  GetTopLeagues_Callback(data) {
    console.log("IN CALLBACK FOR GetTopLeagues_Callback WITH DATA ", data);

    if (!data) {
      console.log("NO DATA!");
      this.showLoadingErrorMessage();
      return;
    }

    //obradi u listu za prikaz
    var leagueList = [];

    //pushaj sve lige
    leagueList.push({
      IDCategory: 0,
      CategoryTitle: "Sve Top lige",
      TournamentTitle: "",
      SportID: -1, //special da bude zvjezdica
      TournamentID: 0,
      Status: 0,
      EventCount: 0
    });

    data.forEach(li => {
      leagueList.push({
        IDCategory: li.IDKategorija,
        CategoryTitle: li.KategorijaNaziv,
        TournamentTitle: li.NazivTurnir,
        SportID: li.SportID,
        TournamentID: li.TurnirID,
        Status: li.Status,
        EventCount: 0
      });
    });

    this.props.setPrematchLeaguesInfo(leagueList);

    var tmpDate = new Date();

    //zovi dalje
    GetSportTournamentItems(
      ConvertLanguageCodeToJezikID(this.props.currentLanguage),
      moment(this.props.chosenDate)
        .add(tmpDate.getTimezoneOffset(), "m")
        .toDate(),
      0,
      -tmpDate.getTimezoneOffset(),
      this.getRequestLastMinOffset(),
      1, //jedinica za top lige
      this.GetSportTournamentItems_Callback.bind(this)
    );
  }

  hideExtraBetsPopup() {
    //gasi extra bets ako su vanka
    this.props.setShouldQuickCloseExtraBets(true);

    this.props.setIsShowingBonusInfo(false);
    this.props.onSetPrematchExtraBetsID(-1);
    this.props.setCanShowExtraPrematchBets(true);

    setTimeout(() => {
      this.props.setShouldQuickCloseExtraBets(false);
    }, 100);
  }

  handleCalendarChange() {
    if (this.props.lastUsedPickerID !== PickerIDs.CALENDAR) {
      console.log("THIS PICKER WASNT USED... CALENDAR");
      return;
    }

    this.hideExtraBetsPopup();

    //gasi mosttip - tj po novom bacaj na prematch!
    this.props.onChangeMostPlayedButtonItem(MostPlayedOptionIDs.PREMATCH);

    this.props.startLoading(false, false);

    var tmpDate = new Date();

    //dohvati i nazive glavnih tipova
    GetTipNamesForMainBets(
      ConvertLanguageCodeToJezikID(this.props.currentLanguage),
      this.GetTipNamesForMainBets_Callback.bind(this)
    );

    //dohvati podatke nove
    GetSportTournamentItems(
      ConvertLanguageCodeToJezikID(this.props.currentLanguage),
      moment(this.props.chosenDate)
        .add(tmpDate.getTimezoneOffset(), "m")
        .toDate(),
      0,
      -tmpDate.getTimezoneOffset(),
      this.getRequestLastMinOffset(),
      0,
      this.GetSportTournamentItems_Callback.bind(this)
    );
  }

  GetTipNamesForMainBets_Callback = data => {
    console.log("IN CALLBACK GetTipNamesForMainBets_Callback WITH DATA ", data);
  };

  GetSportTournamentItems_Callback = data => {
    //obradi da dobijes sportove, kategorije, turnire
    var sports = [];
    var categories = [];
    var tournaments = [];

    if (!data) {
      console.log("NO DATA!");
      this.showLoadingErrorMessage();
      return;
    }

    data.forEach(sctItem => {
      if (sports.findIndex(x => x.IDSport === sctItem.IDSport) === -1) {
        //add
        sports.push({ IDSport: sctItem.IDSport, Title: sctItem.NazivSport });
      }

      if (
        categories.findIndex(x => x.IDCategory === sctItem.IDKategorija) === -1
      ) {
        //add
        categories.push({
          IDCategory: sctItem.IDKategorija,
          TitleCategory: sctItem.NazivKategorija,
          IDSport: sctItem.IDSport,
          TitleSport: sctItem.NazivSport,
          EventCount: 0,
          IconCode: "xxx"
        });
      }

      if (
        tournaments.findIndex(x => x.IDTournament === sctItem.IDTurnir) === -1
      ) {
        //add
        tournaments.push({
          IDTournament: sctItem.IDTurnir,
          TitleTournament: sctItem.NazivTurnir,
          IDCategory: sctItem.IDKategorija,
          TitleCategory: sctItem.NazivKategorija,
          IDSport: sctItem.IDSport,
          TitleSport: sctItem.NazivSport
        });
      }
    });

    //ako je u top ligama, pocisti listu sportova!
    // if (
    //   this.props.activeMostPlayedButtonID === MostPlayedOptionIDs.TOP_LEAGUES
    // ) {
    //   sports = [];
    // }

    //dodaji redom u kategorije i listu turnira za tu kategoriju
    categories.forEach(c => {
      var ts = tournaments.filter(x => x.IDCategory === c.IDCategory);
      c.Tournaments = ts;
    });

    // console.log(
    //   "IN CALLBACK GetSportTournamentItems_Callback WITH DATA ",
    //   data
    // );

    // // console.log("PROCESSED sports: ", sports);
    // console.log("PROCESSED categories: ", categories);
    // console.log("PROCESSED tournaments: ", tournaments);

    this.props.setPrematchCategoriesInfo(
      this.props.currentSportID !== -10 ? categories : null //nema mu jos kategorija ako nije sport odabrao
    );
    this.generateAndSavePicker(sports);

    var tmpDate = new Date();

    this.setState(
      {
        sports: sports,
        categories: categories,
        tournaments: tournaments
      },
      () => {
        //i sada mozes zvati dalje za parove
        GetActivePairItems(
          ConvertLanguageCodeToJezikID(this.props.currentLanguage),
          moment(this.props.chosenDate)
            .add(tmpDate.getTimezoneOffset(), "m")
            .toDate(),
          this.props.activeCalendarItemID === 9 ? this.props.currentSportID : 0, //dohvati svakako uvijek za sve sportove pa filtriraj u callbacku je inace nece raditi filter gore za missing
          //this.props.currentSportID === -10 ? 0 : this.props.currentSportID, //-10 su svi sportovi i saljes 0
          -tmpDate.getTimezoneOffset(),
          this.getRequestLastMinOffset(),
          this.props.activeMostPlayedButtonID ===
            MostPlayedOptionIDs.TOP_LEAGUES
            ? 1
            : 0, //ako je u top ligama salji 1, inace 0
          this.GetActivePairItems_Callback
        );
      }
    );
  };

  showLoadingErrorMessage() {
    var msg = (
      <p>
        Došlo je do greške prilikom preuzimanja podataka!
        <br />
        <br />
        Molimo pokušajte ponovno ili se obratite djelatniku lokala.
      </p>
    );

    this.props.stopLoading(false);
    this.setState({ infoMessage: msg });
  }

  generateAndSavePicker = sports => {
    console.log("generating picker ", sports);

    var picker = [];
    var i = 0;
    sports.forEach(sp => {
      i++;
      picker.push({
        sportID: sp.IDSport,
        title: sp.Title,
        matchCount: 0,
        UIOrderIndex: i
      });
    });

    //provjeri da ima trenutni sport
    if (
      this.props.currentSportID !== -10 &&
      picker.findIndex(x => x.sportID === this.props.currentSportID) === -1 &&
      picker.length > 0
    ) {
      //nema sporta, odaberi sve sportove
      if (this.props.activeCalendarItemID !== 9) {
        //9ka je ALL u kalendaru
        //
      }
      console.log("NEMA SPORTA; DEFAULT NA SVE! ", this.props.currentSportID);
      this.props.onChangeSportPrematch(-10);
    }

    if (this.props.activeMostPlayedButtonID === MostPlayedOptionIDs.PREMATCH) {
      //oznaci prvog ako je trenutno na -10
      if (this.props.currentSportID === -10) {
        if (picker.length > 0) {
          this.props.onChangeSportPrematch(picker[0].sportID);
        }
      }
    }

    this.props.setPrematchPickerInfo(picker);

    //console.log("PICKER DATA JE ", picker);
  };

  GetActivePairItems_Callback = data => {
    console.log("IN CALLBACK GetActivePairItems_Callback WITH DATA ", data);

    if (!data) {
      console.log("NO DATA!");
      this.showLoadingErrorMessage();
      return;
    }

    //obradi u listu kakva pase u prematcheventlist
    var eventList = [];
    var matches = [];

    var tournaments = this.state.tournaments;

    //nista ovo jer dohvacamo uvijek sve sportove
    // if (this.props.currentSportID !== -10) {
    //   //nisu odabrani svi sportovi, filtriraj samo turnire iz ovog sporta
    //   tournaments = tournaments.filter(
    //     x => x.IDSport === this.props.currentSportID
    //   );
    // }

    tournaments.sort((a, b) => {
      //prva razina sort po sportu
      if (a.IDSport !== b.IDSport) {
        return a.IDSport - b.IDSport;
      }

      //druga razina sort po kategoriji
      if (a.IDCategory !== b.IDCategory) {
        return a.TitleCategory > b.TitleCategory ? 1 : -1;
      }

      //treca razina sort po turniru
      return a.TitleTournament > b.TitleTournament ? 1 : -1;
    });

    //idi redom po turnirima i stvaraj grupe i bacaj unutra parove koji pripadaju
    //prvo sortiraj kategorije po nazivu kategorije, onda po nazivu turnira

    //temp, makni
    let tmpDate = new Date();
    let leagueItems = this.props.leagueItems;
    let leagueMatchCounter = 0;
    tournaments.forEach(t => {
      //pronadji parove koji imaju taj turnir
      var pairs = data.filter(x => x.TurnirID === t.IDTournament);

      if (!pairs || pairs.length === 0) {
        //nema parova, vozi dalje
        return;
      }

      //imamo parove, pripremi grupu pa idemo po svakom paru
      let group = {};

      group.sportID = t.IDSport;
      group.id = t.IDTournament;
      group.country = t.TitleCategory;
      group.league = t.TitleTournament;
      group.matches = [];
      group.categoryID = t.IDCategory;
      group.leagueID = t.IDTournament;

      //ako postoji league item postavi mu ovaj count
      if (leagueItems) {
        var li = leagueItems.find(x => x.TournamentID === t.IDTournament);

        // console.log("LEAGUE ITEMS ", leagueItems);
        // console.log("LEAGUE ", li);

        if (li) {
          li.EventCount = pairs.length;
        }
      }

      pairs.forEach(pair => {
        leagueMatchCounter++;
        let betInfo = [];

        //dohvati kvote
        var kvote = pair.KvotaList;

        //za svaku kvotu salji u bet info
        kvote.forEach(kv => {
          betInfo.push({
            betID: kv.IDParKvota,
            changeDirection: 0,
            id: kv.IDParKvota,
            isActive: true,
            isEnabled: true,
            isShown: true,
            kategorijaPonudeID: 1,
            longName: kv.Tip,
            matchID: kv.ParID,
            order: 0,
            shortName: kv.Tip,
            sportVrstaOkladaID: 0,
            value: kv.KvotaVrijednost
          });
        });

        var tmpMatch = {
          id: pair.IDPar,
          homeTeam: pair.DomacinNaziv,
          guestTeam: pair.GostNaziv,
          startTime: moment(pair.DatumUtakmice)
            .add(-tmpDate.getTimezoneOffset(), "m")
            .toDate(),
          betInfo: betInfo,
          betRadarID: pair.BrMatchID,
          numberOfExtraBets: pair.BrojOklada,
          tournamentName: t.TitleTournament,
          sportID: t.IDSport
        };

        group.matches.push(tmpMatch);
        matches.push(tmpMatch);
      });

      eventList.push(group);
    });

    if (leagueItems) {
      //podesi jos event count za sve lige ukupno
      var li = leagueItems.find(x => x.TournamentID === 0); //sve

      if (li) {
        li.EventCount = leagueMatchCounter;
      }
    }

    //postavi state
    this.setState(
      { groups: eventList, rawEventList: eventList, matches: matches },
      () => {
        //i refreshaj listu
        this.updateDisplayedSports();
      }
    );

    //i event items
    this.props.setPrematchLeaguesInfo(leagueItems);

    //console.log("EVENT ITEMS ", eventList);

    //alert("done!");

    this.props.stopLoading(false);
  };

  componentWillMount() {
    //pretplati se na promjenu
    window.addEventListener("storage", this.storageHandler, false);
    document.addEventListener(
      "keydown",
      function(e) {
        this.keyDownTextField(e);
      }.bind(this),
      false
    );
    this.currentText = "";
  }

  keyDownTextField(e) {
    //console.log("INPUT IS: " + this.currentText);

    var keyCode = e.keyCode;
    if (keyCode === 13) {
      //enter
      this.currentText = this.currentText.replace("undefined", "");
      console.log("INPUT IS, SAVING TO LOCALSTORAGE: " + this.currentText);
      //window.cefCustomObject.processKeyboardInput(this.currentText);

      //posalji putem storagea input dole na procesiranje
      localStorage.setItem(
        LocalStorageKeys.LOCALSTORAGE_QR_INPUT,
        this.currentText
      );

      this.currentText = "";
    } else {
      if (
        e.key !== "Shift" &&
        e.key !== "undefined" &&
        e.key !== undefined &&
        e.key !== "NumLock" &&
        e.key !== "ArrowDown"
      ) {
        this.currentText += e.key;

        console.log("THIS ", this);
        console.log("THIS PPS ", this.props);

        //pali loading odmah!
        this.props.startLoading(false, true);
      }
    }
  }

  storageHandler = event => {
    //alert("storage bitch pre!");

    console.log("Storage event for key: ", event.key);

    if (event.key === LocalStorageKeys.LOCALSTORAGE_APPSTATE) {
      //pozovi event
      this.appStateChangedHandler();
    }

    if (event.key === LocalStorageKeys.LOCALSTORAGE_BALANCE) {
      //pozovi event
      this.balanceStateChangedHandler();
    }

    if (event.key === LocalStorageKeys.LOCALSTORAGE_LAST_USER_INTERACTION) {
      //pozovi event
      this.resetTimerForSelf();
    }

    if (event.key === LocalStorageKeys.K_LOCAL_STORAGE_KEY_MACHINE_INFO) {
      //dohvati iz storagea
      var config = localStorage.getItem(
        LocalStorageKeys.K_LOCAL_STORAGE_KEY_MACHINE_INFO
      );

      //pozovi event
      this.processMachineConfig(config);
    }
  };

  processMachineConfig = config => {
    console.log("RECEIVED CONFIG: ", config);
    console.log("PARSED CONFIG: ", JSON.parse(config));

    this.props.setMachineConfig(config);
  };

  appStateChangedHandler = () => {
    console.log("TUUKII");

    //dohvati iz storagea
    var appState = JSON.parse(
      localStorage.getItem(LocalStorageKeys.LOCALSTORAGE_APPSTATE)
    );

    console.log("SERVERSTATUS: Received  from LocalStorage! ", appState);

    //i spremi u state
    this.props.onChangeServerStatus(appState.serverStatusCode, false);

    if (appState.isLoading === true) {
      this.props.startLoading(false, false);
    } else {
      this.props.stopLoading(false);
    }
  };

  balanceStateChangedHandler = () => {
    //console.log("TUUKII BALANCE");

    //dohvati iz storagea
    var balance = JSON.parse(
      localStorage.getItem(LocalStorageKeys.LOCALSTORAGE_BALANCE)
    );

    //console.log("balanceStateChangedHandler: Received  from LocalStorage! ", balance);

    //alert("CURRENT BALANCE IS: " + balance.currentBalance);

    //i spremi u state
    this.props.updateBalance(balance.currentBalance, false);
  };

  render() {
    //stvori klase za extrabets
    let extraBetsClasses = [CssClasses.extraBetsContainer];

    if (this.props.prematchExtraBetsID > 0) {
      //dodaj show
      extraBetsClasses.push(CssClasses.showExtraBetsContainer);
    } else {
      //Dodaj hide
      extraBetsClasses.push(CssClasses.hideExtraBetsContainer);
    }

    //printaj
    // console.log("MATCHESI NSTATE SU: ", this.state.matches);
    // console.log("CURRE EXTRA ID JE ", this.props.prematchExtraBetsID);

    console.log("machine info is ", this.props.machineInfo);

    return (
      <Aux>
        {this.props.isAppLoading ||
        this.props.serverStatusCode !== 200 ||
        this.props.printerStatusList.includes(
          ZebraErrorCodes.ZEBRA_WARNING_PAPER_LOW
        ) ||
        this.props.printerStatusList.includes(
          ZebraErrorCodes.ZEBRA_ERROR_CUTTER_FAULT
        ) ||
        this.props.printerStatusList.includes(
          ZebraErrorCodes.ZEBRA_ERROR_HEAD_OPEN
        ) ||
        this.props.printerStatusList.includes(
          ZebraErrorCodes.ZEBRA_ERROR_MEDIA_OUT
        ) ||
        this.props.printerStatusList.includes(
          ZebraErrorCodes.ZEBRA_ERROR_RIBBON_OUT
        ) ? (
          <FullscreenLoader
            withTransparentBackground={this.props.isLoaderTransparent}
            errorMessage={
              this.props.serverStatusCode !== 200
                ? "Usluga trenutno nije dostupna! Ponovno spajanje..."
                : this.props.printerStatusList.includes(
                    ZebraErrorCodes.ZEBRA_WARNING_PAPER_LOW
                  )
                ? "Papir je pri kraju! Provjerite i zamijenite papir."
                : this.props.printerStatusList.includes(
                    ZebraErrorCodes.ZEBRA_ERROR_CUTTER_FAULT
                  )
                ? "Greška u printeru - Provjerite rezač!"
                : this.props.printerStatusList.includes(
                    ZebraErrorCodes.ZEBRA_ERROR_HEAD_OPEN
                  )
                ? "Greška u printeru - Otvorena glava pisača!"
                : this.props.printerStatusList.includes(
                    ZebraErrorCodes.ZEBRA_ERROR_MEDIA_OUT
                  )
                ? "Greška u printeru - Nema papira u vodilici!"
                : this.props.printerStatusList.includes(
                    ZebraErrorCodes.ZEBRA_ERROR_RIBBON_OUT
                  )
                ? "Greška u printeru - Provjerite ribon!"
                : ""
            }
          />
        ) : null}

        {this.props.machineInfo.CurrentPaperLengthMM <
        this.props.machineInfo.MinPaperLengthMM ? (
          <FullscreenLoader
            withTransparentBackground={false}
            errorMessage={
              "Papir je pri kraju! Obratite se vlasniku objekta da zamijeni papir kako bi se uređaj mogao nastaviti koristiti."
            }
          />
        ) : null}

        <CefMonitor />
        <div className={CssClasses.mainContainer}>
          {this.props.matchForStatisticsID > 0 ? (
            <FullscreenIFrame
              targetURL={
                "https://wwin.com/statistic/?eventID=" +
                this.props.matchForStatisticsID
              }
              btnCloseCallback={this.modalIframe_Callback}
            />
          ) : null}

          <FullscreenModalPopup
            message={this.state.infoMessage}
            btnOkClickCallback={this.modalPopupBtnOk_Callback}
          />
          <Header isPrematchPicker hasLiveSettings hasPrematchLegend />
          <div className={CssClasses.containerLeftSection}>
            <LeftSectionPickers />
          </div>
          <div className={CssClasses.containerMiddleSection}>
            <PrematchEventList eventItems={this.state.groups} />
            <AdditionalBets
              isForPrematch
              allBets={this.state.additionalBetsList}
              allBetsText={this.state.additionalBetsText}
              match={
                this.state.matches
                  ? this.state.matches.find(
                      x => x.id === this.props.prematchExtraBetsID
                    )
                  : null
              }
            />
            <InfoContainer
              showMessage={msg => {
                this.showMessageHandler(msg);
              }}
            />

            {/* renderiraj i extra bets ako treba */}
            <div className={extraBetsClasses.join(" ")}>
              {/* {tmpOklade.map(x => {
                return (
                  <div
                    style={{
                      width: "100%",
                      borderBottom: "1px solid black",
                      background: "#333",
                      height: "30px",
                      padding: "5px 0px 0px 5px"
                    }}
                  >
                    {x}
                  </div>
                );
              })} */}
            </div>
          </div>
          <div className={CssClasses.containerRightSection}>
            <RightSectionTerminalActions />

            <div
              className={CssClasses.adminTapDetector}
              onClick={() => {
                this.tapDetector_Tap();
              }}
            >
              &nbsp;
            </div>
          </div>
        </div>

        <main className={CssClasses.Content}>{this.props.children}</main>
      </Aux>
    );
  }

  tapDetector_Tap = () => {
    console.log("Admin tap");

    clearTimeout(this.timer);
    this.clicks++;

    console.log("KKS ", this.clicks);

    this.timer = setTimeout(
      function() {
        if (this.clicks === 5) {
          //zovi admina
          localStorage.setItem(
            LocalStorageKeys.LOCALSTORAGE_SHOW_ADMIN_LOGIN,
            JSON.stringify({
              timestamp: new Date() //hack da se refresha
            })
          );
        }

        // if (this.clicks === 3) {
        //   alert("tripleclick");
        // }

        this.clicks = 0;
      }.bind(this),
      this.timeout
    );
  };

  showMessageHandler = msg => {
    this.setState({ infoMessage: msg });
  };

  modalPopupBtnOk_Callback = () => {
    this.setState({ infoMessage: null });
  };

  modalIframe_Callback = () => {
    this.props.setMatchForStatisticsID(-1);
  };
}

const mapStateToProps = state => {
  return {
    isAppLoading: state.rrAppState.isLoading,
    isLoaderTransparent: state.rrAppState.isLoadingTransparent,
    prematchExtraBetsID: state.rrNavigation.prematchExtraBetsID,
    serverStatusCode: state.rrAppState.serverStatusCode,
    printerStatusList: state.rrAppState.printerStatuses,
    currentBalance: state.rrBalance.currentBalance,
    activeCalendarItemID: state.rrNavigation.calendarItemID,
    chosenDate: state.rrNavigation.chosenDate,
    currentLanguage: state.rrAppState.currentLanguage,
    currentSportID: state.rrNavigation.prematchSportID,
    currentLeagueID: state.rrNavigation.leagueID,
    currentCategoryID: state.rrNavigation.categoryID,
    activeMostPlayedButtonID: state.rrNavigation.mostPlayedButtonID,
    lastUsedPickerID: state.rrNavigation.lastUsedPickerID,
    leagueItems: state.rrSportEvent.prematchLeagueItems,
    matchForStatisticsID: state.rrNavigation.matchForStatisticsID,
    machineInfo: state.rrAppState.machineInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    startLoading: (isTransparent, updateLocalStorage) =>
      dispatch(StoreActions.StartLoading(isTransparent, updateLocalStorage)),
    stopLoading: updateLocalStorage =>
      dispatch(StoreActions.StopLoading(updateLocalStorage)),
    onChangeServerStatus: (code, updateLocalStorage) =>
      dispatch(StoreActions.ChangeServerStatus(code, updateLocalStorage)),
    updateBalance: (amountInCents, updateLocalStorage) =>
      dispatch(StoreActions.UpdateBalance(amountInCents, updateLocalStorage)),
    setPrematchPickerInfo: picker =>
      dispatch(StoreActions.SetPrematchPickerInfo(picker)),
    setPrematchLeaguesInfo: info =>
      dispatch(StoreActions.SetPrematchLeaguesInfo(info)),
    setPrematchCategoriesInfo: info =>
      dispatch(StoreActions.SetPrematchCategoriesInfo(info)),
    onChangeSportPrematch: sportID =>
      dispatch(StoreActions.ChangeSportPrematch(sportID)),
    onChangeCalendarItem: (calendarItemID, date) =>
      dispatch(StoreActions.ChangeCalendarItem(calendarItemID, date)),
    onChangeMostPlayedButtonItem: buttonID =>
      dispatch(StoreActions.ChangeMostPlayedButtonItem(buttonID)),
    onChangeCurrentCategory: categoryID =>
      dispatch(StoreActions.ChangeCategoryItem(categoryID)),
    onChangeLastUsedPicker: pickerID =>
      dispatch(StoreActions.ChangeLastUsedPicker(pickerID)),
    onChangeCurrentLeague: leagueID =>
      dispatch(StoreActions.ChangeLeagueItem(leagueID)),
    setMatchForStatisticsID: matchID =>
      dispatch(StoreActions.SetMatchForStatisticsID(matchID)),
    setAllBetsText: betsText => dispatch(StoreActions.SetAllBetsText(betsText)),
    setShouldQuickCloseExtraBets: shouldClose =>
      dispatch(StoreActions.SetShouldQuickCloseExtraBets(shouldClose)),
    onSetPrematchExtraBetsID: betsID =>
      dispatch(StoreActions.ChangeCurrentPrematchExtraBetsID(betsID)),
    setCanShowExtraPrematchBets: canShow =>
      dispatch(StoreActions.SetCanShowExtraPrematchBets(canShow)),
    setIsShowingBonusInfo: isShown =>
      dispatch(StoreActions.SetIsShowingBonusInfo(isShown)),
    setTerminalActionsActiveButton: buttonID =>
      dispatch(StoreActions.SetTerminalActionsActiveButton(buttonID)),
    setMachineConfig: config => dispatch(StoreActions.SetMachineInfo(config))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Layout);



// WEBPACK FOOTER //
// ./src/HOCs/LayoutPrematch/LayoutPrematch.js